@if(loaderIcon | async){
<app-loader></app-loader>
}
<div class="container-fluid" [formGroup]="vendorSettingsForm">
  <div class="top_details pb-1">
    <ul>
      <li class="mt-0"><label>Vendor ID</label> <span class="mx-2">:</span>{{vendorMarketID}}</li>
      <li class="mt-0"><label>Name</label> <span class="mx-2">:</span>{{vendorName}}</li>
      <li class="mt-0"><label>Telephone</label><span class="mx-2">:</span>{{telephone | phoneFormat}}</li>
      <li class="mt-0"><label>Email</label><span class="mx-2">:</span>{{Email}}</li>
      <li class="mt-0 d-none"><label>Address</label><span class="mx-2">:</span>{{Address}}</li>
      <li class="mt-0"><label>City</label><span class="mx-2">:</span>{{City}}</li>
    </ul>
  </div>
  <div class="border rounded shadow p-3 mb-3">
    <div class="row">
      <div class="col-md-4 d-flex align-items-center mb-2">
        <div class="mb-2 d-flex align-items-center">
          <input class="form-check-input me-2" type="checkbox" id="excludeRenewal"
            formControlName="ExcludeAutoMonthlyRenewal">
          <label class="form-check-label me-auto" for="excludeRenewal">Exclude from Automatic Monthly Renewal</label>
        </div>
      </div>
      <div class="col-md-4 d-flex align-items-center mb-2">
        <input class="form-check-input me-2" type="checkbox" id="autoRent" formControlName="AutoDeductRent">
        <label class="form-check-label" for="autoRent">Auto Deduct Rent</label>
      </div>
      <div class="col-md-4 d-flex align-items-center mb-2">
        <input class="form-check-input me-2" type="checkbox" id="refundTax" formControlName="RefundPosSalesTax">
        <label class="form-check-label" for="refundTax">Refund POS Sales Tax</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 d-flex align-items-center mb-2 mt-2">
        <input class="form-check-input me-2" type="checkbox" id="checkDealer"
          formControlName="DisablePrintSettlementCheckForDealer">
        <label class="form-check-label" for="checkDealer">Don't Print the Settlement Check for this Dealer</label>
      </div>
      <div class="col-md-4 d-flex align-items-center mb-2">
        <input class="form-check-input me-2" type="checkbox" id="consignmentVendor" formControlName="ConsignmentVendor">
        <label class="form-check-label" for="consignmentVendor">Consignment Vendor</label>
      </div>
    </div>
  </div>
  <div class="border rounded shadow p-3 mb-3">
    <h6 class="fw-semibold mb-3">Commissions</h6>
    <div class="row mb-2 align-items-center">
      <div class="col-md-6 d-flex align-items-center">
        <input class="form-check-input me-2" type="checkbox" id="flatCommission"
          formControlName="ApplyFlatCommissionPos">
        <label class="form-check-label me-auto" for="flatCommission">Apply Flat Commission on POS (%)</label>
      </div>
      <div class="col-md-3">
        <input type="text" class="form-control" formControlName="FlatCommissionPos" appPercentageFormatter
          value="0.00%">
      </div>
    </div>

    <div class="row align-items-center">
      <div class="col-md-6 d-flex align-items-center">
        <input class="form-check-input me-2" type="checkbox" id="rdConsignmentCommission"
          formControlName="EnableConsignmentCommission">
        <label class="form-check-label me-auto" for="rdConsignmentCommission">Consignment Commission (%)</label>
      </div>
      <div class="col-md-3">
        <input type="text" class="form-control" formControlName="ConsignmentCommission" appPercentageFormatter
          value="0.00%">
      </div>
    </div>
  </div>
  <div class="border rounded shadow p-3 mb-3">
    <div class="row g-3">

      <div class="col-md-3">
        <label class="form-label">Insurance #</label>
        <input type="text" class="form-control" formControlName="InsuranceNumber" maxlength="25">
      </div>

      <div class="col-md-3">
        <label class="form-label">Business License #</label>
        <input type="text" class="form-control" formControlName="BusinessLicenseNumber" maxlength="25">
      </div>

      <div class="col-md-3">
        <label class="form-label">BL Expiry Date</label>
        <ejs-datepicker class="form-control p-0" formControlName="BLExpiryDate" [format]="'MM/dd/yyyy'"
          placeholder="MM/DD/YYYY"></ejs-datepicker>
      </div>

      <div class="col-md-3">
        <label class="form-label">SSN</label>
        <!-- <input type="text" class="form-control" formControlName="SSN"> -->
        <ejs-maskedtextbox [mask]="SSNMask" name="ssn" id="ssn" formControlName="SSN"></ejs-maskedtextbox>
      </div>

      <div class="col-md-3">
        <label class="form-label">Date of Birth</label>
        <ejs-datepicker class="form-control p-0" formControlName="DateOfBirth" placeholder="MM/DD/YYYY"
          [format]="'MM/dd/yyyy'"></ejs-datepicker>
      </div>

    </div>
  </div>
  <div class=" border rounded shadow p-3 mb-3">
    <h6 class="fw-semibold mb-3">Vendor Name to be Printed on Check</h6>
    <div class="row g-3">
      <div class="col-md-3">
        <label class="form-label">Name</label>
        <input type="text" class="form-control" formControlName="VendorNameOnCheck">
      </div>
      <div class="col-md-3">
        <label class="form-label">City</label>
        <input type="text" class="form-control" formControlName="VendorCityOnCheck">
      </div>
      <div class="col-md-3">
        <label class="form-label">State Code</label>
        <!-- <select class="form-select"></select> -->
        <!-- <input type="text" class="form-control" formControlName="VendorStateOnCheck"> -->
        <!-- <option [value]="null" disabled selected>Select</option>
        <option *ngFor="let state of statesList" [value]="state.StateCode">
          {{ state.StateName }}
        </option> -->

        <ejs-dropdownlist id="ddlTemplate" [dataSource]="statesList" [fields]="StateDropdownFields"
          formControlName="VendorStateOnCheck" placeholder="Select State">

          <ng-template #itemTemplate let-data>
            {{ data?.StateCode }} | {{ data?.StateName }}
          </ng-template>

          <ng-template #valueTemplate let-data>
            {{ data?.StateCode }}
          </ng-template>

        </ejs-dropdownlist>

      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 text-md-end my-2">
      <button class="btn btnAS me-1" [disabled]="!vendorSettingsForm.dirty"
        (click)="UpdateVendorSetting($event)">Save</button>
      <button class="btn btn-orange" [disabled]="!vendorSettingsForm.dirty" (click)="CancelChanges()">Cancel</button>
    </div>
  </div>
</div>